import React from 'react'
import Step from '../../components/Step'
import Button from '../../elements/Button'
import ButtonContainer from '../../elements/ButtonContainer'
import Input from '../../elements/Input'
import Resi from '../Resi'
import {fieldName, routeName, enforce} from '../HelpersResi'
import HelpIcon from '../../elements/HelpIcon'


const currentExcess = fieldName('currentExcess')
    
export const rules = {
    [currentExcess]: [
        enforce.required("Required"),
    ]
}


export default () => {
    const navigation = Resi.useNavigation();
    const validation = Resi.useValidation();

    async function next(){
        try{
            await validation.validate(rules)
            navigation.goToNext();
        }catch(e){}
    }

    return (
        <Step>
            <h2>What is the excess on your current policy? <HelpIcon label={currentExcess} message=""/></h2>
            <div className="row">
                <div className="col-12 col-md-6">
                    <Input autoFocus field={currentExcess} type="dollar"/>
                </div>
            </div>
            
            <ButtonContainer>
                <Button label="Continue" icon="fas fa-chevron-right" type="primary" callback={ next } />
            </ButtonContainer>
        </Step>
    )
};
